import { defineMeta } from '@/registry/types';

export const threatsListExampleMeta = defineMeta({
  name: 'ThreatsListExample',
  level: 'page',
  category: 'example',
  classification: 'custom',
  description:
    'Reference threats list page: TablePageLayout + search/filter toolbar + DataTable with severity/status chips, row-action Menu, and an empty state.',
  baseLibrary: 'custom',
  importPath: '@/pages/ThreatsListExample',
  supportedStates: ['default', 'filtered', 'empty'],
  designTokens: ['colors', 'spacing', 'severity', 'attackPath'],
  accessibility: [
    'TablePageLayout heading + table semantics.',
    'Row actions use IconButton with an accessible label.',
  ],
  usageExamples: ['<ThreatsListExample />'],
  antiPatterns: ['Example only; adapt data wiring for production.'],
  llmSafe: false,
  whenToUse: ['Reference for threat/attack-path list screens with filtering'],
  whenNotToUse: ['Production without data wiring'],
});

export default threatsListExampleMeta;
